Fundu.Pages.UserSettings = (function($, nv) {

    // Properties
    ///////////////////////////
    var _waitForSMS = false;

    // Private Methods
    ///////////////////////////
    var selectElements = function() {
    }

    var initializeComponents = function(){
    }

    var initalizeSMS = function(){
        Fundu.Components.Sms.init();
        _waitForSMS.resolve(true);
    }

    // Init
    ///////////////////////////

    var initialize = function() {
        _waitForSMS = $.Deferred();
        
        if( ! $("#user-settings").hasClass('disabled') ){
            Fundu.Components.Settings.init();
        }

        // Wait until common is ready (wait for SMS utils to be loaded)
        Fundu.Pages.Common.addListener(initalizeSMS);

        return _waitForSMS;
    }

    var finalize = function() {

    }

    // Reveal public methods
    return {
        init: initialize,
        finalize: finalize
    }

})(jQuery);
